import * as React from 'react';

export function IconArrowRight({
  size = 22,
  color = '#1A1C1E',
}: {
  size?: number;
  color?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M4.77844 10.9997H17.2229M17.2229 10.9997L11.8896 16.333M17.2229 10.9997L11.8896 5.66635"
        stroke={color}
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

IconArrowRight.displayName = 'IconArrowRight';
